import { EmailQuotationReactionGuard } from '@contracting/email-quotation-reaction-store';
import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

const loadChildren = () =>
  import(
    './lib/contracting-email-quotation-reaction-lazy-temporary-library.module'
  ).then(
    (mod) => mod.ContractingEmailQuotationReactionLazyTemporaryLibraryModule
  );

export const emailQuotationReactionLazyImports: ComponentNameAndModule[] = [
  {
    path: 'EmailQuotationReactionHandler',
    loadChildren,
    canActivate: [EmailQuotationReactionGuard],
  },
];
